import { AssignedEquipmentModel, EquipmentModel, EquipmentAcessoryModel, EquipmentWithAssignmentsModel, EquipmentClassCodeModel, EquipmentClassificationModel, EquipmentTypeModel } from './../../../models/equipmentsModel';
import { PagingResultsModel } from './../../../models/pagingResultsModel';
import { createReducer, on, Action } from '@ngrx/store';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { FormError } from 'src/app/models/utilModels';
import {
  getAssignedEquipmentList, getAssignedEquipmentListSuccess, getAssignedEquipments, getAssignedEquipmentsSuccess, updateCreateEquipmentForm,
  createEquipment, createEquipmentFail, createEquipmentSuccess, getMyEquipmentList, getMyEquipmentListSuccess,
  getMyEquipmentListFail, addEquipmentToAssign, AddReturnDate, SetReturnDate, RemoveReturnDate, removeEquipmentToAssign, searchEquipment, searchEquipmentSuccess,
  searchEquipmentFail, saveAssignEquipment, saveAssignEquipmentSuccess, saveAssignEquipmentFail,
  changedUserOnEquipmentToAssign,
  changedAssignedProgramOnEquipmentToAssign,
  clearCreateEquipmentForm,
  getEquipmentAssignPdf,
  getEquipmentAssignPdfSuccess,
  saveReturnEquipment,
  saveReturnEquipmentSuccess,
  saveReturnEquipmentFail,
  signEquipmentAssign,
  signEquipmentAssignSuccess,
  signEquipmentAssignFail,
  addAssigningAcessory,
  removeAssigningAcessory,
  loadUserEquipments,
  loadUserEquipmentsFail,
  loadUserEquipmentsSuccess,
  changedReturnEquipment,
  clearEquipmentsToAssign,
  deleteEquipment,
  deleteEquipmentSuccess,
  deleteEquipmentFail,
  editEquipmentForm,
  loadCampusesSuccess,
  loadClassCodesSuccess,
  loadClassificationsSuccess,
  saveEditAssignEquipment,
  saveEditAssignEquipmentSuccess,
  saveEditAssignEquipmentFail,
  loadEquipmentPermissionModalOptionsSuccess,
  loadEquipmentPermissionsSuccess,
  saveEquipmentPermissionsSuccess,
  clearPermissions,
  getEquipmentTypesSuccess,
  loadManageAssetLocationsSuccess,
  loadManageAssetTypesSuccess,
  setCreateStoredValueOther
} from './equipment.actions';
import { deepClone } from 'src/app/helpers/utils';
import { formatDate } from '@angular/common';
import { CampusModel } from '../../../models/campusModel';
import { ManageAssetLocationModel, ManageAssetTypeModel } from 'src/app/models/manageAssetModels';
export interface EquipmentState {
  loadingDoc: boolean;
  loadingSign: boolean;
  docArrayBuffer: ArrayBuffer;
  docSignedArrayBuffer: ArrayBuffer;

  assigningEquipment: boolean;
  assigningEquipments: AssignedEquipmentModel[];
  assigningAcessories: EquipmentAcessoryModel[];

  equipmentSearchResult: EquipmentModel[];
  searchingEquipments: boolean;

  classCodes: EquipmentClassCodeModel[];
  classifications: EquipmentClassificationModel[];

  savingAssignEquipments: boolean;

  savingReturnEquipments: boolean;
  assignedEquipmentsToUser: AssignedEquipmentModel[];
  loadingUserEquipments: boolean;
  returningEquipments: AssignedEquipmentModel[];

  assignedEquipmentList: PagingResultsModel<EquipmentWithAssignmentsModel>;
  loadingAssignedEquipmentList: boolean;

  assignedEquipments: PagingResultsModel<EquipmentWithAssignmentsModel>;
  loadingAssignedEquipments: boolean;

  equipment: EquipmentModel;
  creatingEquipment: boolean;
  deletingEquipment: boolean;
  equipmentFormErrors: FormError[];
  myEquipments: AssignedEquipmentModel[];
  loadingMyEquipments: boolean;

  userIDReturning: number;
  programIDReturning: number;
  campuses: CampusModel[];
  manageAssetTypes: ManageAssetTypeModel[];
  manageAssetLocations: ManageAssetLocationModel[];

  equipmentPermissionOptions: any;
  equipmentPermissions: any;
  equipmentTypes: EquipmentTypeModel[];
}

const initialState: EquipmentState = {
  loadingDoc: false,
  loadingSign: false,
  docArrayBuffer: null,
  docSignedArrayBuffer: null,

  assigningEquipment: null,
  assigningEquipments: [],
  assigningAcessories: [],

  equipmentSearchResult: [],
  searchingEquipments: false,

  classCodes: [],
  classifications: [],

  savingAssignEquipments: false,

  savingReturnEquipments: false,
  assignedEquipmentsToUser: [],
  loadingUserEquipments: false,
  returningEquipments: [],

  assignedEquipmentList: null,
  loadingAssignedEquipmentList: true,

  assignedEquipments: null,
  loadingAssignedEquipments: false,

  equipment: null,
  creatingEquipment: false,
  deletingEquipment: false,
  equipmentFormErrors: [],

  myEquipments: [],
  loadingMyEquipments: false,

  userIDReturning: 0,
  programIDReturning: 0,
  campuses: [],
  manageAssetTypes: [],
  manageAssetLocations: [],

  equipmentPermissionOptions: null,
  equipmentPermissions: null,
  equipmentTypes: null,
};

export const equipmentReducer = createReducer(initialState,
  on(loadCampusesSuccess, (state, action) => {
    return {
      ...state,
      campuses: action.campuses,
    };
  }),
  on(loadManageAssetTypesSuccess, (state, action) => {
    return {
      ...state,
      manageAssetTypes: action.assetTypes,
    };
  }),
  on(loadManageAssetLocationsSuccess, (state, action) => {
    return {
      ...state,
      manageAssetLocations: action.assetLocations,
    };
  }),
  on(loadClassCodesSuccess, (state, action) => {
    return {
      ...state,
      classCodes: action.classCode,
    };
  }),
  on(loadClassificationsSuccess, (state, action) => {
    return {
      ...state,
      classifications: action.classification,
    };
  }),
  on(getEquipmentTypesSuccess, (state, action) => {
    return {
      ...state,
      equipmentTypes: action.equipmentTypes,
    };
  }),
  on(loadEquipmentPermissionModalOptionsSuccess, (state, action) => {
    return {
      ...state,
      equipmentPermissionOptions: action.equipmentPermissionOptions,
    };
  }),
  on(loadEquipmentPermissionsSuccess, (state, action) => {
    return {
      ...state,
      equipmentPermissions: action.equipmentPermissions,
    };
  }),  
  on(clearPermissions, (state, action) => {
    return {
      ...state,
      equipmentPermissions: null,
    };
  }),  
  on(getAssignedEquipmentList, (state, action) => {
    return {
      ...state,
      loadingAssignedEquipmentList: true
    };
  }),
  on(getAssignedEquipmentListSuccess, (state, action) => {
    return {
      ...state,
      assignedEquipmentList: action.equipmentWithAssignmentList,
      loadingAssignedEquipmentList: false
    };
  }),
  on(getAssignedEquipments, (state, action) => {
    return {
      ...state,
      loadingAssignedEquipments: true
    };
  }),
  on(getAssignedEquipmentsSuccess, (state, action) => {
    return {
      ...state,
      assignedEquipments: action.equipmentWithAssignment,
      loadingAssignedEquipments: false
    };
  }),
  on(updateCreateEquipmentForm, (state, action) => {
    const newEquipment = { ...state.equipment, ...action.equipmentValues };
    const newState = { ...state, ...{ equipment: newEquipment, equipmentFormErrors: action.formErrors } };
    return newState;
  }),
  on(clearCreateEquipmentForm, (state, action) => {
    return {
      ...state,
      equipment: {} as EquipmentModel,
      equipmentFormErrors: []
    };
  }),
  on(editEquipmentForm, (state, action) => {
    return {
      ...state,
      equipment: action.equipment,
      equipmentFormErrors: []
    };
  }),

  on(createEquipment, (state, action) => {
    return {
      ...state,
      creatingEquipment: true
    };
  }),
  on(createEquipmentSuccess, (state, action) => {
    return {
      ...state,
      equipment: action.equipment,
      creatingEquipment: false
    };
  }),
  on(createEquipmentFail, (state, action) => {
    return {
      ...state,
      creatingEquipment: false
    };
  }),

  on(deleteEquipment, (state, action) => {
    return {
      ...state,
      deletingEquipment: true
    };
  }),
  on(deleteEquipmentSuccess, (state, action) => {
    return {
      ...state,
      equipment: null,
      deletingEquipment: false
    };
  }),
  on(deleteEquipmentFail, (state, action) => {
    return {
      ...state,
      equipment: null,
      deletingEquipment: false
    };
  }),

  on(getMyEquipmentList, (state, action) => {
    return {
      ...state,
      loadingMyEquipments: true
    };
  }),
  on(getMyEquipmentListSuccess, (state, action) => {
    return {
      ...state,
      myEquipments: action.equipments,
      loadingMyEquipments: false
    };
  }),
  on(getMyEquipmentListFail, (state, action) => {
    return {
      ...state,
      myEquipments: null,
      loadingMyEquipments: false
    };
  }),
  on(clearEquipmentsToAssign, (state, action) => {
    return {
      ...state,
      assigningEquipments: []
    };
  }),
  on(addEquipmentToAssign, (state, action) => {
    const newList = state.assigningEquipments.slice(0);
    newList.push(deepClone(action.assignedEquipment));
    return {
      ...state,
      assigningEquipments: newList,
    };
  }),
  on(AddReturnDate, (state, action) => {
    const newList =(deepClone(state.assigningEquipments));
    newList.forEach(item => {
      if(item.equipment.id == action.assignedEquipment.equipmentID){
        item.thereIsReturnDate = true;
      }
    });
    return {
      ...state,
      assigningEquipments: newList,
    };
  }),
  on(RemoveReturnDate, (state, action) => {
    const newList =(deepClone(state.assigningEquipments));
    newList.forEach(item => {
      if(item.equipment.id == action.assignedEquipment.equipmentID){
        item.thereIsReturnDate = false;
        item.returnDateString = "";
      }
    });
    return {
      ...state,
      assigningEquipments: newList,
    };
  }),
  on(SetReturnDate, (state, action) => {
    const newList =(deepClone(state.assigningEquipments));
    newList.forEach(item => {
      if(item.equipment.id == action.assignedEquipment.equipmentID){
        item.returnDateString = action.assignedEquipment.returnDateString;
      }
    });
    return {
      ...state,
      assigningEquipments: newList,
    };
  }),
  on(removeEquipmentToAssign, (state, action) => {
    const newList = state.assigningEquipments.slice(0);
    const index = newList.findIndex(e => e.equipmentID === action.assignedEquipment.equipmentID
      && (!action.assignedEquipment.assetLocationID
        || e.equipment?.inventoryAssetLocationID === action.assignedEquipment.assetLocationID)
      && (!action.assignedEquipment.assetItemID || e.assetItemID === action.assignedEquipment.assetItemID));
    if (index >= 0) {
      newList.splice(index, 1);
    }
    return {
      ...state,
      assigningEquipments: newList,
    };
  }),

  on(addAssigningAcessory, (state, action) => {
    const newList = state.assigningEquipments.slice(0);
    const indexEquipment = state.assigningEquipments.findIndex(ae => ae.equipmentID === action.equipmentID);
    const assigningEquipment: AssignedEquipmentModel = deepClone(state.assigningEquipments[indexEquipment]);

    const equipmentAcessories = assigningEquipment.equipmentAcessories ? assigningEquipment.equipmentAcessories : [];
    const acessory: EquipmentAcessoryModel = {
      name: action.name,
      equipmentLabel: assigningEquipment.equipment.brand + ' - ' + assigningEquipment.equipment.model
        + ' - ' + assigningEquipment.equipment.serialNumber
    };
    equipmentAcessories.push(acessory);
    assigningEquipment.equipmentAcessories = equipmentAcessories;

    newList.splice(indexEquipment, 1, assigningEquipment);

    return {
      ...state,
      assigningEquipments: newList,
    };
  }),

  on(removeAssigningAcessory, (state, action) => {
    const newList = state.assigningEquipments.slice(0);
    const indexEquipment = newList.findIndex(e =>
      e.equipmentAcessories && !!e.equipmentAcessories.find(aces =>
        aces.equipmentLabel === action.acessory.equipmentLabel && aces.name === action.acessory.name));
    const assigningEquipment: AssignedEquipmentModel = deepClone(newList[indexEquipment]);
    const indexAcessory = assigningEquipment.equipmentAcessories.findIndex(aces =>
      aces.equipmentLabel === action.acessory.equipmentLabel && aces.name === action.acessory.name);

    assigningEquipment.equipmentAcessories.splice(indexAcessory, 1);

    newList.splice(indexEquipment, 1, assigningEquipment);

    return {
      ...state,
      assigningEquipments: newList,
    };
  }),

  on(changedUserOnEquipmentToAssign, (state, action) => {
    const newList = deepClone(state.assigningEquipments);
    newList.forEach(e => {
      e.userID = action.userID;
      e.assignedProgramID = null;
    });
    return {
      ...state,
      assigningEquipments: newList,
    };
  }),

  on(changedAssignedProgramOnEquipmentToAssign, (state, action) => {
    const newList = deepClone(state.assigningEquipments);
    newList.forEach(e => {
      e.assignedProgramID = action.assignedProgramID;
      e.userID = null;
    });
    return {
      ...state,
      assigningEquipments: newList,
    };
  }),

  on(searchEquipment, (state, action) => {
    return {
      ...state,
      searchingEquipments: true
    };
  }),
  on(searchEquipmentSuccess, (state, action) => {
    return {
      ...state,
      equipmentSearchResult: action.equipments.result,
      searchingEquipments: false
    };
  }),
  on(searchEquipmentFail, (state, action) => {
    return {
      ...state,
      equipmentSearchResult: null,
      searchingEquipments: false
    };
  }),

  on(saveAssignEquipment, (state, action) => {
    return {
      ...state,
      savingAssignEquipments: true
    };
  }),
  on(saveAssignEquipmentSuccess, (state, action) => {
    return {
      ...state,
      savingAssignEquipments: false
    };
  }),
  on(saveAssignEquipmentFail, (state, action) => {
    return {
      ...state,
      savingAssignEquipments: false
    };
  }),

  on(saveEditAssignEquipment, (state, action) => {
    return {
      ...state,
      savingAssignEquipments: true
    };
  }),
  on(saveEditAssignEquipmentSuccess, (state, action) => {
    return {
      ...state,
      savingAssignEquipments: false
    };
  }),
  on(saveEditAssignEquipmentFail, (state, action) => {
    return {
      ...state,
      savingAssignEquipments: false
    };
  }),
  on(getEquipmentAssignPdf, (state, action) => {
    return {
      ...state,
      docArrayBuffer: null,
      loadingDoc: true
    };
  }),
  on(getEquipmentAssignPdfSuccess, (state, action) => {
    return {
      ...state,
      docArrayBuffer: action.doc,
      loadingDoc: false
    };
  }),
  on(signEquipmentAssign, (state, action) => {
    return {
      ...state,
      loadingSign: true
    };
  }),
  on(signEquipmentAssignSuccess, (state, action) => {
    return {
      ...state,
      loadingSign: false
    };
  }),
  on(signEquipmentAssignFail, (state, action) => {
    return {
      ...state,
      loadingSign: false
    };
  }),
  on(loadUserEquipments, (state, action) => {
    return {
      ...state,
      loadingUserEquipments: true,
      userIDReturning: action.userID ?? 0,
      programIDReturning: action.assignedProgramID ?? 0
    };
  }),
  on(loadUserEquipmentsSuccess, (state, action) => {
    return {
      ...state,
      assignedEquipmentsToUser: action.assignedEquipments,
      loadingUserEquipments: false
    };
  }),
  on(loadUserEquipmentsFail, (state, action) => {
    return {
      ...state,
      loadingUserEquipments: false
    };
  }),

  on(saveReturnEquipment, (state, action) => {
    return {
      ...state,
      savingReturnEquipments: true
    };
  }),
  on(saveReturnEquipmentSuccess, (state, action) => {
    return {
      ...state,
      savingReturnEquipments: false
    };
  }),
  on(saveReturnEquipmentFail, (state, action) => {
    return {
      ...state,
      savingReturnEquipments: false
    };
  }),
  on(setCreateStoredValueOther, (state, action) => {
    return {
      ...state,
      equipment: action.equipment
    };
  }),

  on(changedReturnEquipment, (state, action) => {
    const newEquipment = deepClone(action.assignedEquipment);
    const equipmentIndex = state.assignedEquipmentsToUser.findIndex(e => action.assignedEquipment.assetAssignedID
      ? e.assetAssignedID === action.assignedEquipment.assetAssignedID
      : e.equipmentID === action.assignedEquipment.equipmentID);
    const newAssignedEquipmentsToUser = state.assignedEquipmentsToUser.slice(0);
    if (equipmentIndex >= 0) {
      newAssignedEquipmentsToUser.splice(equipmentIndex, 1, newEquipment);
    }

    return {
      ...state,
      assignedEquipmentsToUser: newAssignedEquipmentsToUser
    };
  }),
);

export function equipmentReducerFunc(state: EquipmentState | undefined, action: Action) {
  return equipmentReducer(state, action);
}


export function initCreateEquipmentForm(equipment: EquipmentModel) {
  if (equipment == null) {
    equipment = {} as EquipmentModel;
  }

  let purchaseDate = typeof equipment.purchaseDate !== 'undefined' && equipment.purchaseDate !== null ? equipment.purchaseDate : new Date();

  const form = new UntypedFormGroup({
    id: new UntypedFormControl(equipment.id),
    model: new UntypedFormControl(equipment.model, [Validators.required, Validators.maxLength(255)]),
    purchaseDate: new UntypedFormControl(formatDate(purchaseDate, 'yyyy-MM-dd', 'en-US'), [Validators.required]),
    mainProgramID:new UntypedFormControl(equipment.mainProgramID, [Validators.required]),
    serialNumber: new UntypedFormControl(equipment.serialNumber, [Validators.required, Validators.maxLength(255)]),
    serviceTag: new UntypedFormControl(equipment.serviceTag, [Validators.maxLength(255)]),
    equipmentTypeID: new UntypedFormControl(equipment.equipmentTypeID, [Validators.required, Validators.maxLength(255)]),
    assetTag: new UntypedFormControl(equipment.assetTag, [Validators.required, Validators.maxLength(255)]),
    brand: new UntypedFormControl(equipment.brand, [Validators.required, Validators.maxLength(255)]),
    expressServiceCode: new UntypedFormControl(equipment.expressServiceCode, [Validators.maxLength(255)]),
    department: new UntypedFormControl(equipment.department, [Validators.required, Validators.maxLength(255)]),
    pricing: new UntypedFormControl(equipment.pricing, [Validators.required, Validators.maxLength(255)]),
    purchaseVendor: new UntypedFormControl(equipment.purchaseVendor, [Validators.required, Validators.maxLength(255)]),
    storedLocationID: new UntypedFormControl(equipment.storedLocationID, [Validators.required]),
    storedOther: new UntypedFormControl(equipment.storedOther, [Validators.maxLength(255)]),
    paymentMethod: new UntypedFormControl(equipment.paymentMethod, [Validators.required, Validators.maxLength(255)]),
    size: new UntypedFormControl(equipment.size, [Validators.required, Validators.maxLength(255)]),
    classCodeID: new UntypedFormControl(equipment.classCodeID, [Validators.required]),
    classificationID: new UntypedFormControl(equipment.classificationID, [Validators.required]),
    classificationOther: new UntypedFormControl(equipment.classificationOther, [Validators.maxLength(255)]),
  });

  return form;
}
